.globalSearch {
  width: 100%;
  position: relative;
  z-index: 2;
}
